import { render, staticRenderFns } from "./PerformDash.vue?vue&type=template&id=663fd0d6&scoped=true&"
import script from "./PerformDash.vue?vue&type=script&lang=js&"
export * from "./PerformDash.vue?vue&type=script&lang=js&"
import style0 from "./PerformDash.vue?vue&type=style&index=0&id=663fd0d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663fd0d6",
  null
  
)

export default component.exports